// sagas.js
import { takeEvery, call, put } from 'redux-saga/effects';
import {
  FETCH_DASHBOARD_REQUEST,
} from './actionTypes';
import {
  fetchDashboardSuccess,
  fetchDashboardFailure,
} from './actions';
import { getDashboard } from '../../helpers/backend_helper';
import { reduxSerializedError } from '../../utils/utils';

function* fetchDashboardSaga({ payload }) {
  try {
    const response = yield call(getDashboard, payload);
    yield put(fetchDashboardSuccess(response.data));
  } catch (error) {
    yield put(fetchDashboardFailure(reduxSerializedError(error)));
  }
}

export default function* rootSaga() {
  yield takeEvery(FETCH_DASHBOARD_REQUEST, fetchDashboardSaga);
}